import React, { useMemo } from "react";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import { getActiveHoliday } from "../../utils/holidays";

export const HolidayBanner: React.FC = () => {
  const holiday = useMemo(() => getActiveHoliday(), []);
  if (!holiday) return null;

  const isKasim10 = holiday.type === "kasim10";

  return (
    <Box
      sx={{
        backgroundColor: isKasim10 ? "#1a1a1a" : "#B71C1C",
        color: "#ffffff",
        py: 0.75,
        px: 2,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        gap: 1.5,
        width: "100%",
        flexShrink: 0,
      }}
    >
      {holiday.showAtaturk && (
        <Box
          component="img"
          src="/images/holiday/Ataturk.png"
          alt="Atatürk"
          sx={{
            width: 40,
            height: 40,
            borderRadius: "50%",
            objectFit: "cover",
            objectPosition: "top",
            filter: isKasim10 ? "grayscale(100%)" : "none",
          }}
        />
      )}

      <Typography
        variant="body2"
        fontWeight={600}
        sx={{ color: "inherit", textAlign: "center" }}
      >
        {isKasim10
          ? "10 Kasım 1938 — Atatürk'ü saygı, özlem ve minnetle anıyoruz."
          : `${holiday.name} kutlu olsun!`}
      </Typography>
    </Box>
  );
};
